import React from 'react'

import { Container, BouncingLogo } from './styles'

const Loader = ({ overlay = false, bgColor }) => {
    console.count('Loader Component')

    return (
        <Container overlay={overlay} bgColor={bgColor}>
            <BouncingLogo />
        </Container>
    )
}

export default Loader
